import { Component } from '@angular/core';
import { AlertService } from "@services/alert/alert.service";

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent {

  successes: Alert[] = [];
  successes$ = this.alertService.successes();

  warnings: Alert[] = [];
  warnings$ = this.alertService.warnings();

  errors: Alert[] = [];
  errors$ = this.alertService.errors();
  private alertIdCounter = 0;

  constructor(private alertService: AlertService) {
    this.alertService.successes().subscribe(message => {
      this.successes.push({ id: this.alertIdCounter++, message });
    })

    this.alertService.warnings().subscribe(message => {
      this.warnings.push({ id: this.alertIdCounter++, message });
    });

    this.alertService.errors().subscribe(message => {
      this.errors.push({ id: this.alertIdCounter++, message });
    });
  }

  successAlertClosed(alertId: number) {
    this.successes = this.successes.filter(alert => alert.id !== alertId);
  }

  warningAlertClosed(alertId: number) {
    this.warnings = this.warnings.filter(alert => alert.id !== alertId);
  }

  errorAlertClosed(alertId: number) {
    this.errors = this.errors.filter(alert => alert.id !== alertId);
  }

}

interface Alert {
  id: number;
  message: string;
}
